import { pickFiles } from "./h5-file-picker"

type PickerOptions = {
  cropping?: boolean
  multiple?: boolean
  mediaType?: "photo" | "video" | "any"
  maxFiles?: number
  useFrontCamera?: boolean
}

const ImagePicker = {
  openPicker: (options: PickerOptions = {}) =>
    pickFiles({
      multiple: options.multiple,
      mediaType: options.mediaType ?? "photo",
      maxFiles: options.maxFiles,
    }),

  openCamera: (options: PickerOptions = {}) =>
    pickFiles({
      camera: true,
      useFrontCamera: options.useFrontCamera,
      mediaType: "photo",
    }),

  clean: async () => {},
}

export default ImagePicker
